module.exports = __webpack_public_path__ + "static/media/c16-wifi.bcfe8b5f.png";